import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as discussionActions from '../../../actions/discussionActions';
import { DISCUSSION_TABS_CONSTANTS } from '../../../const';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import { I18n } from 'react-redux-i18n-lite';
import { DayGroupHeader, EmptyState } from '@netexknowledge/smart-components';
import DiscussionCard from './DiscussionCard';
import Paginator from '../../common/Paginator';
import CustomIcon from '../../common/CustomIcon';
import DiscussionCardPlaceholder from '../DiscussionCardPlaceholder';
import { groupDiscussionsByDay } from './discussionGroupingUtils';
import { DISCUSSION_HELP_COLORS, DISCUSSION_TAB_EMPTY_META, DISCUSSION_TYPE_META } from './discussionTypeMeta';
import { translateWithTokens } from '../../../services/translate/translateWithTokens';
import { getHelpTokens } from './DiscussionsHelp';

export class DiscussionListContainer extends Component {
  static propTypes = {
    classroom: PropTypes.object,
    handlePageClick: PropTypes.func,
    discussionActions: PropTypes.object,
    classroomActions: PropTypes.object,
    discussionPages: PropTypes.number,
    currentPage: PropTypes.number,
    discussions: PropTypes.array,
    isFetching: PropTypes.bool,
    tab: PropTypes.object,
    user: PropTypes.object,
    openCreateDiscussionPanel: PropTypes.func,
    hasTabDiscussions: PropTypes.bool,
    activeTypeFilter: PropTypes.string,
    canCreate: PropTypes.bool,
    onShowAllTypes: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.handlePageClick = this.handlePageClick.bind(this);
  }

  getDiscussionsCards(discussions) {
    const { tab, classroom } = this.props;

    if (!discussions || !discussions.length) {
      return [];
    }

    return groupDiscussionsByDay(discussions, tab.key).map((group, groupIndex) => (
      <div className="discussion-day-group" key={`${tab.key}-group-${groupIndex}`}>
        <DayGroupHeader label={group.label} />
        {group.discussions.map((discussion, key) => (
          <DiscussionCard discussion={discussion} key={`${tab.key}-${groupIndex}-${key}`} classroom={classroom} />
        ))}
      </div>
    ));
  }

  handlePageClick(data) {
    const { classroom, discussionActions, tab } = this.props;
    const newPage = data.selected;

    if (tab) {
      switch (tab.key) {
        case DISCUSSION_TABS_CONSTANTS.IN_PROGRESS.key:
          discussionActions.setCurrentDiscussionsCurrentPage(newPage);
          discussionActions.getCurrentDiscussions(classroom.id, newPage);
          break;
        case DISCUSSION_TABS_CONSTANTS.FINISHED.key:
          discussionActions.setFinishedDiscussionsCurrentPage(newPage);
          discussionActions.getFinishedDiscussions(classroom.id, newPage);
          break;
        case DISCUSSION_TABS_CONSTANTS.FUTURE.key:
          discussionActions.setFutureDiscussionsCurrentPage(newPage);
          discussionActions.getFutureDiscussions(classroom.id, newPage);
          break;
        default:
      }
    }
  }

  // The tab has no discussions at all: explain the state, and let the instructor create one.
  renderEmptyTab() {
    const { openCreateDiscussionPanel, tab, canCreate } = this.props;
    const { icon, colors } = DISCUSSION_TAB_EMPTY_META[tab.key];

    return (
      <EmptyState
        size="small"
        icon={<CustomIcon name={icon} size={18} color={colors.icon} />}
        iconBackground={colors.background}
        title={I18n.t(`discussions.emptyTab.${tab.key}.title`)}
        description={translateWithTokens(`discussions.emptyTab.${tab.key}.description`, getHelpTokens())}
        actionLabel={canCreate ? I18n.t('discussions.empty.create') : undefined}
        onAction={canCreate ? openCreateDiscussionPanel : undefined}
      />
    );
  }

  // The tab has discussions, but none of the selected type.
  renderEmptyFilter() {
    const { tab, activeTypeFilter, onShowAllTypes } = this.props;
    const { neutral } = DISCUSSION_HELP_COLORS;

    return (
      <EmptyState
        size="small"
        icon={<CustomIcon name={DISCUSSION_TYPE_META[activeTypeFilter].icon} size={18} color={neutral.icon} />}
        iconBackground={neutral.background}
        title={I18n.t(`discussions.emptyFilter.${activeTypeFilter}.${tab.key}.title`)}
        description={translateWithTokens(
          `discussions.emptyFilter.${activeTypeFilter}.${tab.key}.description`,
          getHelpTokens()
        )}
        actionLabel={I18n.t(`discussions.emptyFilter.showAll.${tab.key}`)}
        onAction={onShowAllTypes}
      />
    );
  }

  renderEmptyDiscussionList() {
    const { hasTabDiscussions, activeTypeFilter } = this.props;
    const isFiltered = hasTabDiscussions && activeTypeFilter && activeTypeFilter !== 'all';

    return isFiltered ? this.renderEmptyFilter() : this.renderEmptyTab();
  }

  renderPlaceholder() {
    return (
      <div className="list-container">
        <DiscussionCardPlaceholder />
      </div>
    );
  }

  render() {
    const { currentPage, discussionPages, discussions, isFetching } = this.props;
    const paginatorConfig = {
      page: currentPage,
      total: discussionPages
    };
    if (isFetching) return this.renderPlaceholder();

    return (
      <div className="list-container">
        <div className="discussions">
          {discussions.length ? this.getDiscussionsCards(discussions) : this.renderEmptyDiscussionList()}
        </div>
        {discussionPages > 1 && <Paginator paginator={paginatorConfig} handlePageClick={this.handlePageClick} />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    classroom: state.classrooms.selectedClassroom.classroom,
    user: state.account.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    discussionActions: bindActionCreators(discussionActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscussionListContainer);
